import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function RealizeConsequences() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Realize the potential consequences and opportunity temptation brings" />
        <blockquote>
          “For the one who sows to his own flesh shall from the flesh reap corruption, but the one who sows to the Spirit shall from the Spirit reap eternal life.” (Galatians 6:8)
        </blockquote>

        <p>All temptation brings about the possibility of negative consequences for those who succumb and blessings for those who successfully resist. The consequences for sinning can be more severe than we ever thought possible and may negatively affect areas of our lives we do not expect, even those areas most precious to us. When we sin, we reject God’s ways and commandments, we ruin our clear conscience before God, and our prayers are hindered. Satan can then more freely advance his many evil causes when Christians choose sin and make themselves “slaves of sin.” Conversely, the benefits of successfully resisting temptation and obeying the will of God are freedom, blessings, and abundant life. We know about men such as Joseph and Job today for the faithfulness they exhibited thousands of years ago in the direst of circumstances, and we see the blessings they enjoyed as a result of their faithfulness. Each time we are tempted we have the opportunity to build up or destroy, to store up blessings on earth and in heaven, or to suffer loss on earth and in heaven. The choice is ours. The second step then in resisting temptation is to quickly realize the consequence of failure and giving in and the rewards for obedience and victory.</p>

        <ul>
          <li>
            <strong>Realize that when you sin, you become a slave of sin; you give up control. “You cannot eat just one.”</strong><br />
            <em>Psalm 119:133, Matthew 6:24, John 8:34, Romans 6:16-20, Galatians 5:17</em>
          </li>
          <br />
          <li>
            <strong>Realize that when you choose sin the consequences will be more severe than you expect or imagine; you may pay for it with what is precious to you.</strong><br />
            <em>1 Samuel 15:22-28, 2 Samuel 12:9-14, Psalm 39:7-11, Galatians 6:7-8, Revelation 2:5</em>
          </li>
          <br />
          <li>
            <strong>Realize that when you choose sin you are rejecting God’s blessings and reward and your prayers will be hindered.</strong><br />
            <em>Psalm 16:11, Romans 2:6-7, 10, 1 Corinthians 3:10-15, 2 Corinthians 5:10, 1 Peter 3:7, Revelation 2:7, 10, 17, 25-28, 3:5, 12, 20-21</em>
          </li>
          <br />
          <li>
            <strong>Realize that when you sin you may be causing your little ones to stumble, or giving Satan permission to attack loved ones or affect things important to you. You are the first line of defense for those under your care, and you can affect many more than just yourself!</strong><br />
            <em>Exodus 20:4-6, 2 Samuel 12:14, Job 31:9-12, Proverbs 5:7-14, Matthew 18:6-10</em>
          </li>
          <br />
          <li>
            <strong>Realize that when you choose sin you are despising the blood and Name of Jesus Christ, you are mocking God, and you are testing His patience. You are suppressing the truth in unrighteousness.</strong><br />
            <em>Matthew 4:7, Luke 4:12, Acts 5:9, Romans 1:18, Hebrews 6:1-9, 10:26-29</em>
          </li>
          <br />
          <li>
            <strong>Realize that when you choose sin God’s enemies will use you as an excuse to mock and blaspheme God.</strong><br />
            <em>Job 1:9-11, 2:3-6, 2 Samuel 12:14, Romans 2:17-24</em>
          </li>
          <br />
          <li>
            <strong>Realize that when you successfully resist temptation you are proving you love the Lord Jesus and are a true follower of His. Don’t behave in the same way as the lost and perishing.</strong><br />
            <em>Matthew 7:15-27, 25:41-46, John 14:15, 21, Romans 2:25-29, 1 Corinthians 6:9-10, Galatians 5:19-21, 1 John 3:7-10, Revelation 21:8, 22:15</em>
          </li>
          <br />
          <li>
            <strong>Realize that the temptation may be for your testing, to prove your faithfulness, so God can bless you and entrust more to you (e.g. examples of Joseph and Job). View temptation as an opportunity to grow stronger in Christ and bring glory to God (but don’t go looking for it).</strong><br />
            <em>Genesis 39, 41, Exodus 20:4-6, Job 1:8-12, 2:3-6, 42:10-17, Romans 5:3-5, Galatians 6:7-8, 1 Peter 1:6-7, 2 Peter 1:9-11</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
